import React, { useState } from 'react';
import styled from 'styled-components';
import Accordion from 'components/Accordion';
import SectionTitle from 'components/SectionTitle';
import { questions } from 'utils/commomQuestions';
import FaqVideosSection from './FaqVideosSection';

export default function FaqSection() {
  const [showQuestions, setShowQuestions] = useState(12);

  const handleLoadMore = () => {
    setShowQuestions(showQuestions + 12);
  };

  const handleLoadLess = () => {
    setShowQuestions(12);
  };

  return (
    <Container>
      <HowWorks>
        <h2>Como Funciona?</h2>
        <FaqVideosSection />
      </HowWorks>
      <Wrapper>
        <SectionTitle>Perguntas Frequentes</SectionTitle>
        {questions.slice(0, showQuestions).map(question => (
          <Accordion key={question.id} title={question.text}>
            <span dangerouslySetInnerHTML={{ __html: question.description ? question.description : '' }} />
          </Accordion>
        ))}

        {showQuestions > 30 &&
          <InfoMessage>
            <strong>Caso não tenha encontrado aqui a resposta </strong>
            adequada para a sua pergunta, entre em contato conosco, através da aba “Contato” que fica no menu superior do site ou através do nosso e-mail contato@nossavaquinha.com.br.<br /><br />
            Descreva seu problema e sua pergunta. Será um prazer te ajudar!<br /><br />
            Atenciosamente,<br /><br />
            Equipe Nossa vaquinha.
          </InfoMessage>
        }
        <ButtonLoadList onClick={showQuestions < 30 ? handleLoadMore : handleLoadLess}>
          {showQuestions < 30 ? "Ver mais perguntas" : "Ver menos"}
        </ButtonLoadList>
      </Wrapper>
    </Container>
  );
}

const HowWorks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 40px 0px;
  position: relative;

  h2 {
    font-family: 'P22 Mackinac Pro';
    font-style: normal;
    font-weight: 500;
    font-size: 35px;
    line-height: 120%;
    text-align: center;
    color: #000000;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.174);

    @media (max-width: 478px) {
      padding: 20px;
      text-align: center;
    }
  }

  p {
    font-size: 17px;
    color: #ffffff;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.166);
  }

  @media (max-width: 778px) {
    padding: 50px 10px 0px;
  }
`;

const Container = styled.div`
  min-height: calc(90vh - (80px + 190px));
`;


const Wrapper = styled.div`
  margin-top: 15rem;
  & > *:not(:first-child) {
    margin-top: 3rem;
  }
`;

const ButtonLoadList = styled.button`
  padding: 15px 45px;
  border-radius: 8px;
  text-transform: uppercase;
  border: none;
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 110%;
  margin-top: 20px;
  background-color: #174F68;
  width: 100%;
  max-width: 415px;
  padding: 15px 48px;
  font-size: 18px;
  text-transform: uppercase;
  color: #fff;
  border: none;
  margin-top: 20px;
  border-radius: 8px;
  margin-right: 50px;
  cursor: pointer;

  & > a {
    font-family: Nunito;

    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: center;
  }

  @media (max-width: 478px) {
    margin-right: 0;
    margin-bottom: 30px;
    font-size: 14px !important;
    width: 90%;
  }

  a {
    color: #FBF9ED !important;
  }
`;

const InfoMessage = styled.div`
  font-size: 18px;
  margin-left: 1.5rem;
`;